var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"mb-4",attrs:{"xl":"2","md":"4","sm":"6","xs":"12"}},[_c('div',{class:[_vm.classObj, _vm.color],style:({ paddingTop: '75%' })}),_vm._t("default"),_c('color-view')],2)}
var staticRenderFns = []

export { render, staticRenderFns }